



































import Vue from 'vue';

export default Vue.extend({
    name: 'App',
    data: () => ({}),
    async mounted() {
        console.log(this.$store);
    },
    computed: {
        theme() {
            return (this.$vuetify.theme.dark) ? 'dark' : 'light'
        }
    },
});
